const firebaseConfig = {
    apiKey: "AIzaSyCaSueGJe49hVWCjmrKjaq3wa0FiRYxcCM",
    authDomain: "spacegram-b511c.firebaseapp.com",
    databaseURL: "https://spacegram-b511c.firebaseio.com",
    projectId: "spacegram-b511c",
    storageBucket: "spacegram-b511c.appspot.com",
    messagingSenderId: "995856240775",
    appId: "1:995856240775:web:fcb89440962a2911efe822"
  };
export default firebaseConfig;